/******* En-tête ********/

.enteteAccueil {
  background: url("../../../images/accueil/entete.png") center / cover no-repeat;
  height: 750px;
}

.imgFameFamirea {
  max-height: 120px;
}
.imgFameFamirea img {
  max-height: 100%; /* L'image ne dépasse pas la hauteur du conteneur */
}
.login {
  font: Roboto, sans-serif;
}

/******* Titre et sous-titre de site ********/

.titreAccueil {
  font:
    12rem "Rubik",
    sans-serif;
}

@media screen and (max-width: 1400px) {
  .titreAccueil {
    font-size: 6rem;
  }
}
.sousTitreAccueil {
  font-family: "Rubik", sans-serif;
}
